export default "__VITE_ASSET__B0PEqEL7__"